import { useCallback } from "react"
import { useGlobalState } from "resources/GlobalStateContext"

export const useUIUtils = () => {
    const { setGlobalTitulo } = useGlobalState()

    const changeGlobalTitle = useCallback((title = null, subtitle = "") => {
        setGlobalTitulo(prev => ({
            ...prev,
            titulo: title || prev.title ,
            subtitulo: subtitle
        }))
    }, [setGlobalTitulo])

    return { changeGlobalTitle }
}
